import {regionsMapping, stateMapping} from './mapping';

// Constants
const smallStates = ['RN', 'PB', 'AL', 'SE', 'DF', 'ES', 'RJ'];
const regionsLinks = document.querySelectorAll('.q-region-link');
const stateLinks = document.querySelectorAll('.q-state-link');

// Functions
const getStatesPathFromRegion = region => {
  return Array.from(document.getElementById(region).querySelectorAll('path'));
};

const getRegionLabelsFromRegion = region => {
  return Array.from(document.getElementById(region).querySelectorAll('.q-label-icon-state'));
};

const isNotSmallState = label => !smallStates.includes(label.innerHTML);

const addEventToAllNodes = (nodes, eventName, eventFunction) => {
  Array.from(nodes).map(element => element.addEventListener(eventName, eventFunction));
};

const getStateLabel = state => document.getElementById(stateMapping[state].label);

const getStateShape = state => document.getElementById(stateMapping[state].shape);

const handleHighlightRegion = (e) => {
  const regionName = e.target.text;
  const regionId = regionsMapping[regionName];
  const states = getStatesPathFromRegion(regionId);
  const regionLabels = Array.from(getRegionLabelsFromRegion(regionId)).filter(isNotSmallState);
  states.map(state => state.classList.toggle('q-shape--primary'));
  regionLabels.map(label => label.classList.toggle('q-label-icon-state--light'));
};

const handleHighlightState = (e) => {
  const stateName = e.target.pathname.split('/').slice(-1).pop();
  getStateShape(stateName).classList.toggle('q-shape--primary');
  const stateLabel = getStateLabel(stateName);
  if (isNotSmallState(stateLabel)) stateLabel.classList.toggle('q-label-icon-state--light');
};

// Calls
addEventToAllNodes(regionsLinks, 'mouseover', handleHighlightRegion);
addEventToAllNodes(regionsLinks, 'mouseout', handleHighlightRegion);
addEventToAllNodes(stateLinks, 'mouseover', handleHighlightState);
addEventToAllNodes(stateLinks, 'mouseout', handleHighlightState);
